/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem, RelatedContentModal, SelectField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const TAGS = [
  { value: 'athletes_commission', label: "Athlete's Commission" },
  { value: 'sustainability', label: 'Sustainability' },
  { value: 'refugee_team', label: 'Refugee Team' },
  { value: 'organisation', label: 'Organisation' },
  { value: 'alumni_club', label: 'Alumni Club' },
  { value: 'waPriority', label: 'WA Priority' },
  { value: 'world_plan', label: 'World Plan' },
  { value: 'partners', label: 'Partners' },
  { value: 'plaque', label: 'Plaque' },
  { value: 'throw', label: 'Throw' },
  { value: 'jump', label: 'Jump' },
  { value: 'run', label: 'Run' },
  { value: 'mfs', label: 'MFs' },
  { value: 'hq', label: 'HQ' },
];
const TAG_MAP = TAGS.reduce((acc, tag) => ({ ...acc, [tag.value]: tag }), {});

const TAG_FIELD = {
  name: 'tag',
  options: TAGS,
  selectOptions: { placeholder: 'Choose a tag:' },
  rules: [{ required: true, message: 'Tag is required' }],
};

const RelatedTagModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add tag"
    subtitle="Find a tag related to this article"
    okText="ADD TAG"
    onSubmit={({ tag }) => onSubmit(tag)}
  >
    <SelectField {...TAG_FIELD} style={NO_MARGIN_BOTTOM} />
  </RelatedContentModal>
);

const Item = (tagKey) => {
  const tagLabel = TAG_MAP[tagKey]?.label;

  return <InfoItem>{tagLabel || tagKey}</InfoItem>;
};

RelatedTagModal.Item = Item;

export default RelatedTagModal;
